import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';

const SearchableCriterion = ({
  selectedCriteria,
  criterion,
  deselectCriterion,
  selectCriterion,
  noDescription,
  canUseCustomFeedbackCriteria,
  editTooltip,
  currentUserId,
  toggleModalState,
}) => {
  const isSelected =
    selectedCriteria.filter(item => item.id === criterion.id).length > 0;
  const [selected, setSelected] = useState(isSelected);
  const didMount = useRef(false);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    if (selected) {
      selectCriterion(criterion);
    } else {
      deselectCriterion(criterion);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  const toggleSelect = () => setSelected(!selected);

  const criterionClassNames = classNames(
    'AddCriteriaModal-criterion d-f jc-sb ai-c',
    {
      'AddCriteriaModal-selectedCriterion': selected,
    },
  );
  const isCustomCriterion =
    criterion.type === 'FeedbackCriteria::CustomCriterion';
  const criterionIsEditable = canUseCustomFeedbackCriteria && isCustomCriterion;
  const canEditCriterion = criterion.creator_id === currentUserId;

  return (
    <div
      className={criterionClassNames}
      onClick={toggleSelect}
      onKeyDown={e => e.key === 'Enter' && toggleSelect()}
    >
      <div className="fg-1">
        <span className={selected ? 'c-white' : 'c-brand-night'}>
          {criterion.name}
        </span>
        <span className={selected ? 'c-white' : 'c-brand-gray'}> &ndash; </span>
        <span className={selected ? 'c-white' : 'c-brand-gray-darker'}>
          {criterion.description || <em>{noDescription}</em>}
        </span>
      </div>
      {criterionIsEditable && canEditCriterion && (
        <button
          type="button"
          data-html="true"
          data-toggle="tooltip"
          title={editTooltip}
          data-placement="top"
          className="f-sh-0 u-resetBtn editCriterionButton"
          onClick={() => toggleModalState(criterion)}
        >
          <Icon name="edit" className="ml-8" />
        </button>
      )}
    </div>
  );
};

export default SearchableCriterion;
